import { SliderInput } from "./SliderInput";

export default SliderInput;
